import cubejs from '@cubejs-client/core';

import { appConfig } from '~/common/config';
import { userManager } from '~/services/oidc';

export const cubeApi = cubejs(
  async () => {
    const user = await userManager.getUser();
    return user?.access_token ?? '';
  },
  {
    apiUrl: appConfig.cube.url,
  },
);
